
    $(document).ready(function(){
        // Hero styles and data attr
        heroStyles($(".hero__section-content h1"));
        heroStyles($(".hero__section-content p"));
    })
    
    // Style hero content function
    function heroStyles(item){
    
      var dataColor = item.attr("data-color");  
    
      // check if data attr is empty element color => default color
      if(dataColor === null){
        item.css({"color":"#000000"});
      }else{
        item.css({"color":dataColor});
      }
    
      // Check if html tag is empty. If true hide Element.
      item.each(function(index){
        if($(this).is(":empty")){
          $(this).css({"display":"none"})
        }
      })
        
    }

    

